import styled from "styled-components";
import FixaTabs, {
  FixaTab,
  FixaTabPanel,
} from "../../../shared/wrappers/FixaTabs/FixaTabs";
import Trans from "../../../../../packages/locales/translations/util/Trans";

const StyledFixaTabs = styled(FixaTabs)`
  padding: 0 64px;
  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

const StyledFixaTabPanel = styled(FixaTabPanel)`
  padding: 0;
`;

interface TableTabsProps {
  activeTab: number;
  changeTab: (index: number) => void;
  tabPanels: React.ReactNode[];
}

const TableTabs = ({ activeTab, changeTab, tabPanels }: TableTabsProps) => {
  return (
    <StyledFixaTabs
      activeTab={activeTab.toString()}
      onTabChanged={(tabId) => {
        changeTab(parseInt(tabId));
      }}
      tabPanels={tabPanels.map((children: React.ReactNode, index: number) => (
        <StyledFixaTabPanel key={index} tabPanelId={index.toString()}>
          {children}
        </StyledFixaTabPanel>
      ))}
      tabs={[
        <FixaTab key="1" tabPanelId="0" text={<Trans>teamsString</Trans>} />,
        <FixaTab key="2" tabPanelId="1" text={<Trans>usersString</Trans>} />,
      ]}
    />
  );
};

export default TableTabs;
